<template>
  <NConfirm variant="alert" :title="title" @close="$emit('close')" @confirm="$emit('confirm')"><slot /></NConfirm>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import NConfirm from '@/modules/global/components/core/NConfirmModal/NConfirm.vue'

@Component({
  components: { NConfirm }
})
export default class NAlert extends Vue {
  @Prop({ type: String }) title: NConfirm['title']
}
</script>

<style scoped lang="scss"></style>
